/* ════ VIEWS ═══════════════════════════════════════════════ */
import { state } from './state.js';
import { $, $$ } from './dom.js';
import { renderIdeas } from './ideas.js';
import { renderList } from './listview.js';
import { renderHistory } from './historyview.js';
import { renderCostDash } from './costdash.js';
import { renderCo2 } from './co2board.js';
import { renderLeaveView } from './leave.js';
import { buildGantt } from './gantt/index.js';
import { pdate, addD } from './utils/date.js';
import { openEdit } from './modals/task.js';

export function setView(name) {
  state.currentView = name;
  $$('.vtab').forEach(x => x.classList.toggle('on', x.dataset.view === name));
  $('view-gantt').classList.toggle('on', name === 'gantt');
  $('view-list').classList.toggle('on', name === 'list');
  $('view-ideas').classList.toggle('on', name === 'ideas');
  $('view-history').classList.toggle('on', name === 'history');
  $('view-costs').classList.toggle('on', name === 'costs');
  $('view-co2').classList.toggle('on', name === 'co2');
  $('view-leave').classList.toggle('on', name === 'leave');
  // The CO₂ board shares the planner's date-window controls.
  $('gantt-controls').style.display = (name === 'gantt' || name === 'co2') ? 'flex' : 'none';
  const fb = $('filter-bar'); if (fb) fb.style.display = (name === 'gantt' || name === 'list') ? 'flex' : 'none';
  if (name === 'gantt') buildGantt();
  if (name === 'co2') renderCo2();
  if (name === 'list') renderList();
  if (name === 'ideas') renderIdeas();
  if (name === 'history') renderHistory();
  if (name === 'costs') renderCostDash();
  if (name === 'leave') renderLeaveView();
}

// Jump from the List view to a task in the Planner: navigate to its dates,
// flash it, and open its details.
export function focusTask(id) {
  const t = state.tasks.find(x => String(x.id) === String(id)); if (!t) return;
  state.viewStart = addD(pdate(t.start), -2);
  setView('gantt');
  setTimeout(() => {
    const el = $(`tb-${id}`);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      el.classList.add('flash');
      setTimeout(() => el.classList.remove('flash'), 1500);
    }
    openEdit(id);
  }, 90);
}

export function initViews() {
  $$('.vtab').forEach(b => b.addEventListener('click', () => setView(b.dataset.view)));
}
